import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import { YellowButton } from '../../components/YellowButton'
import { BorderedPageLayout } from '../BorderedPageLayout'
import { BackButton } from '../../components/BackButton'
import { SearchIcon } from '../../icons'
import useTheme from '../../hooks/useAppColor'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { AnalysisItem } from '../../components/ListItems/AnalysisItem'
import { useDeferred } from '../../hooks/useDeffered'
import { usePagination } from '../../hooks/usePagination'
import { getUsiProducts, incrementProductsPart, resetProducts } from '../../features/products/productSlice'
import { getProductById } from '../../features/current-data/currentData'
import { handleAnalysisInfoModal } from '../../features/modals/modalsSlice'

export const OrderUSIAnalysis = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const getTheme = useTheme()

    const cart = useAppSelector(state => state.cart)
    const cartProducts = useAppSelector(state => state.cart.items)
    const { items, part, loadings, can_next } = useAppSelector(state => state.products)

    const [searchVal, setSearchVal] = useState("")
    const deferredSearchVal = useDeferred(searchVal, 500)

    const [loadProducts, loadMore] = usePagination(
        () => dispatch(getUsiProducts({ part, title: deferredSearchVal })),
        () => dispatch(incrementProductsPart()),
        {
            part,
            can_more: can_next,
            items,
            loading: loadings.pagination
        }
    )

    const handleOpenProductInfo = (product_id: number) => {
        dispatch(handleAnalysisInfoModal())
        dispatch(getProductById({ id: product_id }))
    }

    useEffect(() => {
        dispatch(resetProducts())
    }, [dispatch, deferredSearchVal])

    useEffect(() => {
        return () => {
            dispatch(resetProducts())
        }
    }, [dispatch])

    useEffect(() => {
        loadProducts()
    }, [part])

    return (
        <BorderedPageLayout
            contentClassName={"f-column-betw"}
            top={
                <div className='f-row-betw'>
                    <BackButton onClick={() => navigate("/order/usi")} />
                    <h2 className={`${getTheme("", "c-white")} title fw-6`}>УЗИ</h2>
                    <div></div>
                </div>
            }>
            <div className="f-column-betw f-1 gap-30">
                <div className="f-column gap-25">
                    <div className="f-row-betw">
                        <h2 className={`title ${getTheme("", "c-white")}`}>Выберите тип диагностики</h2>
                    </div>
                    <div className="f-column gap-15">
                        <div className={`d-f pd-10 al-center gap-5 search-block w-100p ${getTheme("", "app-bg-dark svg-gray-filled")}`}>
                            <SearchIcon />
                            <input
                                value={searchVal}
                                onChange={(e) => setSearchVal(e.target.value)}
                                className={`w-100p fz-m ${getTheme("", "c-white")}`}
                                type="text"
                                placeholder='Найти по названию анализа'
                            />
                        </div>
                    </div>
                </div>
                <div className="f-1 p-rel">
                    {!loadings.products ? (
                        <div className="list p-abs w-100p f-column scrollableItemsList gap-10">
                            {items.length ? (
                                [...items]
                                    .sort((a, b) => a.name.localeCompare(b.name))
                                    .map((item, index) => (
                                        <AnalysisItem
                                            clickHandle={() => handleOpenProductInfo(item.id)}
                                            product={item}
                                            isInCart={cartProducts.some(cartProduct => cartProduct.id === item.id)}
                                            index={index}
                                            key={item.id}
                                        />
                                    ))
                            ) : (
                                <div style={{ padding: "10px 0" }}>
                                    <p className={`fz-m ${getTheme("c-dark", "c-white")}`}>Ничего не найдено.</p>
                                </div>
                            )}
                            {can_next ? (
                                <div style={{ marginTop: 15 }} className="f-c-col">
                                    <YellowButton className='fz-s mini-btn' onClick={loadMore} loading={loadings.pagination}>Загрузить еще</YellowButton>
                                </div>
                            ) : null}
                        </div>
                    ) : (
                        <div className="f-column gap-5">
                            <Skeleton borderRadius={6} height={50} />
                            <Skeleton borderRadius={6} height={50} />
                            <Skeleton borderRadius={6} height={50} />
                        </div>
                    )}
                </div>
                <YellowButton disabled={cart.items.length === 0} className='f-c-row gap-10' onClick={() => navigate("/order/cart")}>
                    Корзина
                    <div className="countYellowWhite fz-s">{cart.items.length}</div>
                </YellowButton>
            </div>
        </BorderedPageLayout>
    )
}
